var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Menu_Icons",
    "data-name": "Menu Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1763",
    "data-name": "Rectangle 1763",
    width: 25,
    height: 25,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6022",
    "data-name": "Path 6022",
    d: "M6.482,16.984l.5,2.006A1.827,1.827,0,0,0,8.665,20.3h1.353A1.827,1.827,0,0,0,11.7,18.99l.5-2.006a1.3,1.3,0,0,1,1.628-.939l1.986.568a1.827,1.827,0,0,0,1.979-.8l.677-1.173a1.83,1.83,0,0,0-.3-2.114l-1.486-1.436a1.3,1.3,0,0,1,0-1.882l1.483-1.436a1.828,1.828,0,0,0,.3-2.113l-.678-1.173a1.827,1.827,0,0,0-1.978-.8l-1.986.568a1.3,1.3,0,0,1-1.63-.939l-.5-2A1.827,1.827,0,0,0,10.019,0H8.665A1.827,1.827,0,0,0,6.984,1.313l-.5,2a1.3,1.3,0,0,1-1.63.941L2.868,3.688a1.827,1.827,0,0,0-1.979.8L.213,5.66a1.829,1.829,0,0,0,.3,2.115L1.994,9.208a1.305,1.305,0,0,1,0,1.883L.508,12.527a1.83,1.83,0,0,0-.3,2.114l.678,1.173a1.827,1.827,0,0,0,1.979.8l1.986-.568a1.3,1.3,0,0,1,1.628.938m2.86-9.54a2.707,2.707,0,1,1-2.707,2.707A2.707,2.707,0,0,1,9.342,7.444",
    transform: "translate(3.16 2.349)",
    fill: "none",
    stroke: "#5b788f",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/icon_settings.cd3f9c0c70538d20f5d8b51c2efd3353.svg";
export { ForwardRef as ReactComponent };